import {useState, useEffect} from 'react'
import {Link, useParams, useNavigate} from 'react-router-dom'
import {approve} from '../core/_requests'
import {useIntl} from 'react-intl'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'
import {useLocation} from 'react-router-dom'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {useAuth} from '../core/Auth'
import {getUserByToken, getToken, resendVerificationCode} from '../core/_requests'
import Swal from 'sweetalert2'

interface LocationState {
  userName: any
}

const initialValues = {
  verificationCode: '',
}

export function EmailVerification() {
  const intl = useIntl()
  const location = useLocation()
  const navigate = useNavigate()
  //const {userName, password} = (location.state as {userName: string; password: string}) || {}
  const {userName} = (location.state as {userName: string}) || {}
  const loginSchema = Yup.object().shape({
    verificationCode: Yup.string().required(intl.formatMessage({id: 'AUTH.VerificationCode'})),
  })

  const [loading, setLoading] = useState(false)
  const [endTime, setEndTime] = useState<Date | null>(null)
  const [timeLeft, setTimeLeft] = useState(0)
  const [canResend, setCanResend] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()

  // Zamanlayıcıyı başlat
  useEffect(() => {
    if (userName) {
      // Auth'tan gelen yönlendirme durumunu kontrol et
      const startTimer = () => {
        const now = new Date().getTime()
        const expiration = now + 180000 // 3 dakika (180 saniye)
        setEndTime(new Date(expiration))
      }

      startTimer()
    } else {
      navigate('/auth')
    }
  }, [userName])

  // Kalan zamanı hesaplama
  useEffect(() => {
    const interval = setInterval(() => {
      if (endTime) {
        const now = new Date().getTime()
        const difference = endTime.getTime() - now
        if (difference <= 0) {
          clearInterval(interval)
          setTimeLeft(0)
          setCanResend(true)
        } else {
          setTimeLeft(difference)
        }
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [endTime])

  // Tekrar Kod Gönderme
  const handleResendCode = async () => {
    setCanResend(false)
    try {
      const response = await resendVerificationCode(userName)

      if (response?.data?.status === 'Success') {
        // Başarılı durumda Swal gösterme, sadece timer'ı sıfırla
        const now = new Date().getTime()
        const expiration = now + 180000 // 3 dakika
        setEndTime(new Date(expiration))
      } else {
        // Backend'den status 'Error' dönerse hata mesajı göster
        Swal.fire({
          icon: 'error',
          title: 'Hata!',
          text: response?.data?.message || 'Beklenmeyen bir hata oluştu.',
        })
      }
    } catch (error: any) {
      // Hata durumunda gösterilecek mesaj
      Swal.fire({
        icon: 'error',
        title: 'Hata!',
        text:
          error.response?.data?.message ||
          error.message ||
          'Kod gönderilemedi, lütfen tekrar deneyin.',
      })
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,

    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await getToken(userName, values.verificationCode)

        saveAuth(auth)
        const {data: user} = await getUserByToken()
        setCurrentUser(user)
      } catch (error: any) {
        //console.error(error)
        // Eğer hata backend'den geliyorsa, mesajı kullanıcıya göster
        if (error.response && error.response.data && error.response.data.message) {
          // Formik hata durumunu göster
          setStatus(error.response.data.message)
        } else {
          setStatus('Bir hata oluştu, lütfen tekrar deneyin.')
        }
        saveAuth(undefined)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  // Zamanı dakika:saniye formatına dönüştür
  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60000)
    const seconds = Math.floor((time % 60000) / 1000)
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
  }

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>
          {useIntl().formatMessage({id: 'EmailVerificationTitle'})}
        </h1>

        <p className='text-muted'>{intl.formatMessage({id: 'AUTH.VerificationCodeSentMessage'})}</p>
        <p className='text-muted'>
          {/* {intl.formatMessage({id: 'AUTH.ResendCodeTimer'})}:{' '} */}
          {timeLeft > 0 ? formatTime(timeLeft) : ''}
        </p>
      </div>
      {/* begin::Heading */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div className='p-3 rounded'>
          <div className='text-light text-center'></div>
        </div>
      )}

      {/* begin::Form group */}
      {/* <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>
          {useIntl().formatMessage({id: 'Email'})}
        </label>
        <input
          value={userName}
          disabled // Alanı devre dışı bırak
          className={clsx('form-control form-control-lg form-control-solid')}
          type='text'
          name='userName'
        />
      </div> */}
      {/* end::Form group */}

      {/* begin::Form group */}
      {/* <div className='fv-row mb-10'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>
          {useIntl().formatMessage({id: 'Password'})}
        </label>
        <input
          value={password}
          disabled // Alanı devre dışı bırak
          className={clsx('form-control form-control-lg form-control-solid')}
          type='password'
          name='password'
        />
      </div> */}
      {/* end::Form group */}

      {/* Verification Code Field */}
      <div className='fv-row mb-10'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>
          {intl.formatMessage({id: 'VerificationCode'})}
        </label>
        <input
          placeholder={intl.formatMessage({id: 'VerificationCode'})}
          {...formik.getFieldProps('verificationCode')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.verificationCode && formik.errors.verificationCode},
            {'is-valid': formik.touched.verificationCode && !formik.errors.verificationCode}
          )}
          type='text'
          name='verificationCode'
          autoComplete='off'
        />
        {formik.touched.verificationCode && formik.errors.verificationCode && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.verificationCode}</span>
            </div>
          </div>
        )}
      </div>

      {/* Tekrar Kod Gönder Butonu */}
      <div className='text-center mb-10'>
        <button
          type='button'
          onClick={handleResendCode}
          className='btn btn-secondary'
          disabled={!canResend}
        >
          {intl.formatMessage({id: 'AUTH.ResendCode'})}
        </button>
      </div>

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-dark w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && (
            <span className='indicator-label'>{intl.formatMessage({id: 'Submit'})}</span>
          )}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'Please_wait'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        <div className='d-flex flex-center flex-column-auto p-5'>
          <div className='d-flex align-items-center fw-bold fs-6'>
            <span className='text-muted px-2 pt-7'>
              <a
                href='http://www.unipa.com.tr'
                target='_blank'
                rel='noreferrer'
                className='text-muted text-hover-dark px-2'
              >
                Unipa
              </a>
              {intl.formatMessage({id: 'Developed_by'})}
              {/* Tarafından Geliştirilmiştir. */}
            </span>
          </div>
        </div>
      </div>
      {/* end::Action */}
    </form>
  )
}
